<!--
 * @Description: 
 * @Autor: txp
 * @Date: 2021-06-04 14:05:10
-->
<template>
  <div class="container">
    <div class="flex flex-j-c-space-between mgb20">
      <span class="label">发货明细单号：<span class="value">{{itemData.deliveryCode}}</span></span>
      <span class="label">商品数：<span class="value red">{{itemData.actualNum}}</span></span>
      <span class="label">发货时间：<span class="vaule red">{{itemData.moveDate}}</span></span>
      <span class="label">状态：<span>{{itemData.stateName}}</span></span>
    </div>
    <div class="flex flex-j-c-space-between flex-a-i-center">
      <span class="time">{{itemData.moveDate}}</span>
      <el-button type="primary" size="small" @click="deliverDetails">发货单详情</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemData: Object
  },
  data: ()=> {
    return {

    }
  },
  methods: {
    /**
     * 发货单详情
     */
    deliverDetails(e) {
      this.$router.push({name:'deliveryDetailsInfo',params:{detail:{...this.itemData}}})
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    padding: 20px;
    border: 1px solid rgb(223, 223, 223);
    border-radius: 10px;
    margin-top: 20px;
    .label{
      font-size: 14px;
    }
    .time{
      font-size: 12px;
    }
    .red{
      color: red;
    }
    .mgb20{
      margin-bottom: 20px;
    }
    .flex {
      display: flex;
    }
    .flex-j-c-space-between{
      justify-content: space-between;
    }
    .flex-a-i-center{
      align-items: center;
    }
  }
</style>